import gql from 'graphql-tag';

import { BrandFragments } from './fragments/BrandType';
import { CatchFragments } from './fragments/CatchType';
import { FishingMethodFragments } from './fragments/FishingMethodType';
import { FishingWaterFragments } from './fragments/FishingWaterType';
import { ImageFragments } from './fragments/ImageType';
import { PostFragments } from './fragments/PostType';
import { ProductFragments } from './fragments/ProductType';
import { ProductUnitFragments } from './fragments/ProductUnitType';
import { SpeciesFragments } from './fragments/SpeciesTypes';
import { UserFragments } from './fragments/UserType';
import { WeatherAndMarineReadingFragments } from './fragments/WeatherAndMarineReadingType';

export const getCatchPostComments = gql`
  query GetCatchPostComments($externalId: String, $first: Int) {
    post(externalId: $externalId) {
      ...PostId
      comments(first: $first) {
        totalCount
        edges {
          cursor
          node {
            ...PostId
            createdAt
            likedByCurrentUser
            likesCount
            text {
              text
            }
            user {
              ...UserAvatar
              ...UserId
              nickname
            }
            comments(first: 20) {
              edges {
                node {
                  ...PostId
                  createdAt
                  likedByCurrentUser
                  likesCount
                  user {
                    ...UserAvatar
                    ...UserId
                    nickname
                  }
                  text {
                    text
                  }
                }
              }
              totalCount
            }
          }
        }
      }
      likedByCurrentUser
      likesCount
    }
  }
  ${PostFragments.id}
  ${UserFragments.avatar}
  ${UserFragments.id}
`;

export const getCatchDetails = gql`
  query GetCatchDetails($externalId: String) {
    catchDetails: post(externalId: $externalId) {
      ...PostId
      catchConditions: catch {
        ...CatchId
        caughtAtLocalTimeZone
        latitude
        longitude
        moonIllumination
        sunPosition
        weatherAndMarineReading {
          ...WeatherAndMarineReadingId
          airPressure
          airTemperature
          waterTemperature
          weatherCondition {
            localizedValue
            worldWeatherOnlineIdentifier
          }
          windDirection {
            degrees
            shortLocalizedValue
          }
          windSpeed
        }
      }
      catchPost: catch {
        ...CatchId
        catchAndRelease
        caughtAtGmt
        createdAt
        fishingMethod {
          ...FishingMethodId
          displayName
        }
        fishingWater {
          ...FishingWaterId
          displayName
          latitude
          longitude
        }
        hasExactPosition
        length
        locationPrivacy
        species {
          ...SpeciesId
          displayName
        }
        user {
          ...UserId
          avatar {
            url
          }
          nickname
        }
        weight
      }
      trip {
        id
        catches {
          totalCount
        }
      }
      catchGear: displayProductUnits(first: 20) {
        edges {
          node {
            ...ProductUnitId
            product {
              ...ProductId
              brand {
                ...BrandId
                name
              }
              image {
                ...ImageFields
              }
              displayName
            }
          }
        }
      }
    }
  }
  ${BrandFragments.id}
  ${CatchFragments.id}
  ${FishingMethodFragments.id}
  ${FishingWaterFragments.id}
  ${ImageFragments.imageFields}
  ${SpeciesFragments.id}
  ${PostFragments.id}
  ${ProductFragments.id}
  ${ProductUnitFragments.id}
  ${UserFragments.id}
  ${WeatherAndMarineReadingFragments.id}
`;

export const getCatchImages = gql`
  query GetCatchImages($externalId: String) {
    post(externalId: $externalId) {
      ...PostId
      images(first: 12, width: 960) {
        edges {
          node {
            ...ImageFields
          }
        }
      }
    }
  }
  ${ImageFragments.imageFields}
  ${PostFragments.id}
`;
